import { render, staticRenderFns } from "./RelatorioUserView.vue?vue&type=template&id=384379f1"
import script from "./RelatorioUserView.vue?vue&type=script&lang=js"
export * from "./RelatorioUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports